export default __webpack_public_path__ + "assets/models/9f57580e28bfde6b2a18a0c14a40d6c5.glb";